import { v4 as uuidv4 } from "uuid"

const postMessage = (data) => (
  new Promise((resolve, reject) => {
    if (!window.ReactNativeWebView) return reject("error")

    const messageId = uuidv4()

    window.ReactNativeWebView.postMessage(
      JSON.stringify({ messageId, data })
    )

    const handleReceive = (e) => {
      const message = JSON.parse(e.data || "")

      if (message.messageId !== messageId) return

      resolve(message.data)

      document.removeEventListener("message", handleReceive)
    }

    document.addEventListener("message", handleReceive)
  })
)

const RNWebViewApi = { postMessage }

export default RNWebViewApi